import Blytics, { ImpressionListingsDOM } from "@/lib/Blytics"

$(document).on("turbo:load", ImpressionListingsDOM)
$(document).on("turbo:load", function () {
  window.Blytics = Blytics
})
